/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum TransactionType {
    TRANSFER = 'TRANSFER',
    ISSUE = 'ISSUE',
    REDEMPTION = 'REDEMPTION',
    CANCELLATION = 'CANCELLATION',
    ISSUE_SPLIT = 'ISSUE_SPLIT',
    REDEMPTION_REVERSE_SPLIT = 'REDEMPTION_REVERSE_SPLIT',
    TRANSFER_CONVERSION = 'TRANSFER_CONVERSION',
    SHAREHOLDER_CONTRIBUTION = 'SHAREHOLDER_CONTRIBUTION',
    REDUCTION_IN_SHARE_CAPITAL = 'REDUCTION_IN_SHARE_CAPITAL',
    CONVERSION_SHARE_CAPITAL = 'CONVERSION_SHARE_CAPITAL',
    DIVIDEND = 'DIVIDEND',
    VESTING_EVENT = 'VESTING_EVENT',
}
